import { render, staticRenderFns } from "./UOMDetail.vue?vue&type=template&id=32df3e0b&"
import script from "./UOMDetail.vue?vue&type=script&lang=js&"
export * from "./UOMDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports